import React, { Suspense } from 'react';

/**
 * Suspense boundary for a code-split screen.
 *
 * Every admin and settings screen in the app is rendered conditionally and most
 * users never open any of them — an admin hub a salesperson cannot reach, an
 * import wizard, org settings. Loading all of that up front made the main
 * bundle carry roughly a third of the app's source for a first paint that is
 * always the map. They are React.lazy imports now, and this is what the user
 * sees for the moment a chunk is fetched.
 *
 * Boundaries are per screen rather than one around the whole region: a shared
 * boundary would blank every sibling while any one chunk loaded.
 */

const Spinner = () => (
  <div
    className="w-8 h-8 rounded-full border-2 border-gray-600 border-t-blue-400 animate-spin"
    role="status"
    aria-label="Loading"
  />
);

const Deferred = ({ children, overlay = false }) => (
  <Suspense
    fallback={
      overlay ? (
        // Modals: hold the same dimmed ground the screen itself will land on,
        // so opening one does not flash the page behind it.
        <div className="settings-shell items-center justify-center bg-black/60">
          <Spinner />
        </div>
      ) : (
        <div className="flex-1 min-h-0 flex items-center justify-center py-20">
          <Spinner />
        </div>
      )
    }
  >
    {children}
  </Suspense>
);

export default Deferred;
